import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-assets-uploader',
    templateUrl: './assets-uploader.component.html',
    styleUrl: './assets-uploader.component.scss',
    standalone: false
})
export class AssetsUploaderComponent {
  @Input() title: string = '';
  @Input() field: string = '';
  @Input() isFile: boolean = false;
  @Output() fileNameChange = new EventEmitter<any | null>();
  @Input() MAX_File_SIZE: number = 3000000; // 3MB
  @Input() projectAssets: any;
  @Input() formGroup!: FormGroup;

  fileSizeErr: boolean = false;
  fileName!: string;
  isdeleteUploadedFile: boolean = false;

  handleFileInput(files: FileList) {
    this.fileSizeErr = false;
    this.isdeleteUploadedFile = true;
    const file = files[0];
    if (file && file.size < this.MAX_File_SIZE) {
      this.fileName = file.name;
      this.formGroup.get(this.field)?.setValue(file);
      this.fileNameChange.emit({
        field: this.field,
        file: file,
      });
    } else {
      this.fileSizeErr = true;
      this.fileNameChange.emit({
        field: this.field,
        file: null,
      });
    }
  }

  deleteFile() {
    if (this.projectAssets) {
      this.projectAssets = null;
      this.formGroup.get(this.field)?.setValue('');
    }
  }

  deleteUploadedFile() {
    this.isdeleteUploadedFile = false;
    this.formGroup.get(this.field)?.setValue('');
    this.fileNameChange.emit(false);
  }
}
